import { useQuery } from "@tanstack/react-query";

import { getMatchLineups } from "../api";
import { useFixtureScore } from "../stores";
import { pollIntervalMs } from "../utils/refreshCadence";

export const useMatchLineups = (matchId?: string) => {
  const matchInfo = useFixtureScore((state) => state.match);
  const kickoffTime = matchInfo?.matchDateTime;

  const { error, data, isLoading, refetch } = useQuery({
    queryKey: [`match-lineups-${matchId}`],
    queryFn: () => getMatchLineups(matchId as string),
    refetchOnWindowFocus: false,
    enabled: !!matchId?.length,
    staleTime: 0,
    refetchInterval: () => pollIntervalMs("matchLineups", kickoffTime),
    gcTime: 120000,
  });

  const contestants = matchInfo?.contestants ?? [];
  const homeContestant = contestants[0];
  const awayContestant = contestants[1];
  const isHomeTBD = !homeContestant?.id;
  const isAwayTBD = !awayContestant?.id;

  const teamAdata = isHomeTBD
    ? null
    : data?.matchLineups?.find(
        (lineup) => lineup.contestant.id === homeContestant.id
      ) ?? null;
  const teamBdata = isAwayTBD
    ? null
    : data?.matchLineups?.find(
        (lineup) => lineup.contestant.id === awayContestant.id
      ) ?? null;

  const homeContestantCode =
    teamAdata?.contestant.code ??
    teamAdata?.contestant.shortName ??
    teamAdata?.contestant.name ??
    homeContestant?.code ??
    homeContestant?.shortName ??
    homeContestant?.name ??
    "";
  const awayContestantCode =
    teamBdata?.contestant.code ??
    teamBdata?.contestant.shortName ??
    teamBdata?.contestant.name ??
    awayContestant?.code ??
    awayContestant?.shortName ??
    awayContestant?.name ??
    "";

  const lineupsData = {
    teamA: {
      teamName: isHomeTBD ? "TBD" : (teamAdata?.contestant.name ?? homeContestant?.name ?? ""),
      teamCode: isHomeTBD ? "TBD" : homeContestantCode,
      formationUsed: teamAdata?.formationUsed?.split("").join("-") ?? "",
      players:
        teamAdata?.players.map((player) => ({
          name: player.matchName,
          jerseyNumber: player.shirtNumber,
          position: player.position,
          isCaptain: !!player.captain,
          id: player.playerId,
        })) ?? [],
      contestantId: teamAdata?.contestant?.id,
      teamOfficials: teamAdata?.teamOfficials ?? [],
    },
    teamB: {
      teamName: isAwayTBD ? "TBD" : (teamBdata?.contestant.name ?? awayContestant?.name ?? ""),
      teamCode: isAwayTBD ? "TBD" : awayContestantCode,
      formationUsed: teamBdata?.formationUsed?.split("").join("-") ?? "",
      players:
        teamBdata?.players.map((player) => ({
          name: player.matchName,
          jerseyNumber: player.shirtNumber,
          position: player.position,
          isCaptain: !!player.captain,
          id: player.playerId,
        })) ?? [],
      contestantId: teamBdata?.contestant?.id,
      teamOfficials: teamBdata?.teamOfficials ?? [],
    },
  };
  return {
    error: error,
    data: lineupsData,
    isLoading,
    refetch,
  };
};
